import { Route, Routes, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { InteractiveBackground } from './components/InteractiveBackground';

import { Landing } from './routes/Landing';
import { Grid } from './routes/Grid';
import { Spawn } from './routes/Spawn';
import { Lineage } from './routes/Lineage';
import { Leaderboard } from './routes/Leaderboard';
import { Manifesto } from './routes/Manifesto';

export function App() {
  return (
    <div className="relative min-h-screen flex flex-col">
      <InteractiveBackground />
      <Navbar />
      <main className="relative z-10 flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/grid" element={<Grid />} />
          <Route path="/spawn" element={<Spawn />} />
          <Route path="/lineage" element={<Lineage />} />
          <Route path="/lineage/:agentId" element={<Lineage />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/manifesto" element={<Manifesto />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
